import React, { useState } from 'react';

import { Popover } from 'devextreme-react/popover';
import List, { ListTypes } from 'devextreme-react/list';

import SessionDetailDto from '../../classes/dtos/usersessionmodule/SessionDetailDto';
import CustomerWithWorkspacesDto from '../../classes/dtos/accountmodule/CustomerWithWorkspacesDto';
import CustomerApi from '../../api/CustomerApi';
import { UserRolesHelper } from '../../logics/usermodule/UserRolesHelper';
import { CustomerColorHelper } from '../../logics/accountmodule/CustomerColorHelper';
import './SessionDetail.css';

interface SessionDetailProps {
    session: SessionDetailDto;
}

interface CustomerWorkspaceRow {
    Key: string;
    CustomerId: number;
    CustomerName: string;
    WorkspaceId: number;
    WorkspaceName: string;
    EnterpriseMode: boolean;
    IsCurrent: boolean;
}

function toRows(customers: Array<CustomerWithWorkspacesDto>): CustomerWorkspaceRow[] {
    return customers.flatMap((customer) =>
        customer.Workspaces.map((workspace) => ({
            Key: `${customer.Id}-${workspace.Id}`,
            CustomerId: customer.Id,
            CustomerName: customer.Name,
            WorkspaceId: workspace.Id,
            WorkspaceName: workspace.Name,
            EnterpriseMode: customer.EnterpriseMode,
            IsCurrent: customer.IsCurrent && workspace.IsCurrent
        }))
    );
}

const renderRow = (data: CustomerWorkspaceRow) => {
    return (
        <div className="session-detail__dropdown-row">
            <span className="session-detail__dropdown-current">
                {data.IsCurrent && <img width={12} height={12} src="svgs/circle.svg" alt="current" />}
            </span>
            <span className="session-detail__dropdown-color" style={{ backgroundColor: CustomerColorHelper.getColorForCustomer(data.CustomerId) }} />
            <span className="session-detail__dropdown-customer">{data.CustomerName}</span>
            {data.EnterpriseMode && (
                <span className="session-detail__dropdown-workspace">{data.WorkspaceName}</span>
            )}
        </div>
    );
}

const SessionDetail: React.FC<SessionDetailProps> = ({ session }) => {

    const [isOpen, setIsOpen] = useState(false);
    const [rows, setRows] = useState<Array<CustomerWorkspaceRow> | null>(null);

    const toggleOpen = () => {
        if (!isOpen && !rows) {
            CustomerApi.GetCustomerListWithWorkspacesAsync().then((result) => {
                if (!result.IsFailed()) {
                    setRows(toRows(result.Result));
                }
            });
        }
        setIsOpen((previous) => !previous);
    };

    const handleItemClick = (e: ListTypes.ItemClickEvent<CustomerWorkspaceRow>) => {
        const row = e.itemData;

        if (!row || row.IsCurrent) {
            return;
        }

        CustomerApi.SwitchCustomerAsync(row.CustomerId, row.WorkspaceId).then((result) => {
            if (!result.IsFailed()) {
                window.location.reload();
            }
        });
    };

    return (
        <>
            <div id="session-detail-trigger" className="session-detail" onClick={toggleOpen}>
                <span className="session-detail__customer">
                    {session.CustomerName}
                </span>
                {session.EnterpriseMode && (
                    <span className="session-detail__workspace">
                        {session.WorkspaceName}
                    </span>
                )}
                <span className="session-detail__role">
                    {UserRolesHelper.getRoleNameById(session.Role)}
                </span>
            </div>
            <Popover
                target="#session-detail-trigger"
                visible={isOpen}
                onHiding={() => setIsOpen(false)}
                hideOnOutsideClick={true}
                position="bottom"
                width={360}
                showTitle={false}
                wrapperAttr={{ class: 'session-detail-popover' }}
            >
                <div style={{ maxHeight: document.documentElement.scrollHeight * 0.8, overflowY: 'auto' }}>
                    <List
                        dataSource={rows || []}
                        keyExpr="Key"
                        itemRender={renderRow}
                        selectionMode="none"
                        onItemClick={handleItemClick}
                        noDataText="Loading..."
                    />
                </div>
            </Popover>
        </>
    );
}

export default SessionDetail;
